import { useState, useEffect } from "react";
import axios from "axios"

import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import SubHeaderPurchase from "../../../../Components/ComponentsIndustry/SubHeaderPurchase";
import ProviderCard from "../../../../Components/ComponentsIndustry/ProviderCard";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import CountFooter from "../../../../Components/ComponentsIndustry/CountFooter";
import { Supplier } from "../../../../Supplier/Supplier";
import { useRawMaterial } from "../../../../providers/RawMaterialContext";
import { useValue } from "../../../../providers/ValueContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Container, SizeContainer, TitleContent } from "./style";
import { useUser } from "../../../../providers/UserContext";

const ToolsPurchaseCarryBag = () => {
  const history = useHistory()
  const { insumoSacola, setInsumoSacola, getStockInsumo } = useRawMaterial();
  const {
    outputValue,
    setOutputValue,
    outputValueThirty,
    setOutputValueThirty,
    outputValueSixty,
    setOutputValueSixty,
    entranceValue
  } = useValue();

  let [idProvider, setIdProvider] = useState(0)

  let [providerA, setProviderA] = useState(false);
  let [inCashA, setInCashA] = useState(false);
  let [thirtyDaysA, setThirtyDaysA] = useState(false);
  let [totalA, setTotalA] = useState(0);
  let [amountA, setAmountA] = useState(0);

  let [providerB, setProviderB] = useState(false);
  let [inCashB, setInCashB] = useState(false);
  let [thirtyDaysB, setThirtyDaysB] = useState(false);
  let [sixtyDaysB, setSixtyDaysB] = useState(false);
  let [totalB, setTotalB] = useState(0);
  let [amountB, setAmountB] = useState(0);

  const [message, setMessage] = useState('')

  let [providerC, setProviderC] = useState(false);
  let [inCashC, setInCashC] = useState(false);
  let [thirtyDaysC, setThirtyDaysC] = useState(false);
  let [sixtyDaysC, setSixtyDaysC] = useState(false);
  let [totalC, setTotalC] = useState(0);
  let [amountC, setAmountC] = useState(0);

  const [sales, setSales] = useState(0);
  const [prodPlanning, setProdPlanning] = useState(0);
  const { user, rodada, industry, jogo } = useUser()

  function pagamento(data) {

    if (entranceValue > Number(data.total)) {
      axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/compra/cadastrar", data)
        .then(response => {

          if (response.data?.sucesso) {
            alert("Compra efetuada!")
            axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoqueInsumo/obterEstoqueIndustria/6/${industry?.industria}`)
              .then(responseEstoque => {
                var dateUpdated = insumoSacola
                dateUpdated.estoqueInicial = responseEstoque.data?.quantidade
                setInsumoSacola(dateUpdated)
              })
          } else {
            alert("Compra não pôde ser efetuada. " + response.data?.mensagem)
          }

        })
        .catch(error => console.log(error))
      // history.push("/toolsPurchaseCondiment")
    } else {
      alert("Saldo Insuficiente")
    }
  }


  const handlePay = () => {

    const data = {
      "fornecedor": {
        "fornecedor": idProvider
      },
      "industria": industry,
      "insumo": {
        "insumo": 6,
      },
      "pagamento": "",
      "preco": 0,
      "quantidade": 0,
      "rodada": rodada,
      "total": 0
    }

    if (providerA === true) {
      data.quantidade = parseFloat(amountA) * Number(Supplier[3].sacola.fornecedorA.confiabilidade.replace("%", "")) / 100;
      data.preco = 200;
      data.total = parseFloat(totalA);
      if (inCashA === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalA);
      } else {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalA + (totalA * 5) / 100));
      }
    }

    if (providerB === true) {
      data.quantidade = parseFloat(amountB) * Number(Supplier[3].sacola.fornecedorB.confiabilidade.replace("%", "")) / 100;
      data.preco = 200;
      data.total = parseFloat(totalB);
      if (inCashB === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalB);
      } else if (thirtyDaysB === true) {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalB + (totalB * 5) / 100));
      } else {
        data.pagamento = "60dias";
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalB + (totalB * 10) / 100));
      }
    }

    if (providerC === true) {
      data.quantidade = parseFloat(amountC) * Number(Supplier[3].sacola.fornecedorC.confiabilidade.replace("%", "")) / 100;
      data.preco = 200;
      data.total = totalC;
      if (inCashC === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalC);
      } else if (thirtyDaysC === true) {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalC + (totalC * 5) / 100));
      } else {
        data.pagamento = "60dias";
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalC + (totalC * 10) / 100));
      }
    }
    setInsumoSacola({
      estoqueInicial: insumoSacola.estoqueInicial,
      precoMedio: insumoSacola.precoMedio,
      cobertura: insumoSacola.cobertura,
      totalCompra: totalA + totalB + totalC,
      prevVenda: insumoSacola.prevVenda,
      quantidadeCompra:
        parseFloat(amountA) + parseFloat(amountB) + parseFloat(amountC),
    });
  };

  useEffect(() => {
    if (user && rodada) {

      getStockInsumo()

      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterInsumo/${6}/${industry?.industria}/${rodada.rodada}`)
        .then(response => {
          // const data = response.data[0]

          setInsumoSacola({
            estoqueInicial: insumoSacola.estoqueInicial,
            precoMedio: insumoSacola.precoMedio,
            cobertura: insumoSacola.cobertura,
            totalCompra: insumoSacola.totalCompra,
            prevVenda: insumoSacola.prevVenda,
            prevProducao: response.data.producao ? response.data.producao : 0,
            quantidadeCompra: insumoSacola.quantidadeCompra,
          })

        })

    }

  }, [setInsumoSacola, user, rodada])

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/purchase_button.svg"
          title="Compras"
          subTitle="(Insumos e Fornecedores)"
          style={["", "selection", "", "", ""]}
        />
        <SubHeaderPurchase
          setMessage={setMessage}
          style={["", "", "", "", "selection", "", ""]}
          product="Embalagem Plástica"
          initialStock={insumoSacola.estoqueInicial}
          averagePrice={insumoSacola.estoqueInicial * insumoSacola.precoMedio}
          productionPlanning={insumoSacola.prevProducao}
          roof={insumoSacola.cobertura}
          sales={sales}
          setSales={setSales}
          prodPlanning={insumoSacola.prevProducao}
          setProdPlanning={setProdPlanning}
        />

        <TitleContent>
          <img src="./images/marketplace.svg" alt="marketplace" />
          Fornecedores de <span>Embalagem Plástica</span>
        </TitleContent>

        <ProviderCard
          setIdProvider={setIdProvider}
          Supplier={Supplier[3].sacola}
          title1="Fornecedor A"
          minQuant1={Supplier[3].sacola.fornecedorA.minQuant}
          precoBase1={Supplier[3].sacola.fornecedorA.precoBase}
          leadTime1={Supplier[3].sacola.fornecedorA.leadTime}
          atraso1={Supplier[3].sacola.fornecedorA.atraso}
          confiabilidade1={Supplier[3].sacola.fornecedorA.confiabilidade}
          desconto1={Supplier[3].sacola.fornecedorA.desconto}
          provider1={providerA}
          setProvider1={setProviderA}
          inCash1={inCashA}
          setInCash1={setInCashA}
          thirtyDays1={thirtyDaysA}
          setThirtyDays1={setThirtyDaysA}
          total1={totalA}
          setTotal1={setTotalA}
          amount1={amountA}
          setAmount1={setAmountA}
          title2="Fornecedor B"
          minQuant2={Supplier[3].sacola.fornecedorB.minQuant}
          precoBase2={Supplier[3].sacola.fornecedorB.precoBase}
          leadTime2={Supplier[3].sacola.fornecedorB.leadTime}
          atraso2={Supplier[3].sacola.fornecedorB.atraso}
          confiabilidade2={Supplier[3].sacola.fornecedorB.confiabilidade}
          desconto2={Supplier[3].sacola.fornecedorB.desconto}
          provider2={providerB}
          setProvider2={setProviderB}
          inCash2={inCashB}
          setInCash2={setInCashB}
          thirtyDays2={thirtyDaysB}
          setThirtyDays2={setThirtyDaysB}
          sixtyDays2={sixtyDaysB}
          setSixtyDays2={setSixtyDaysB}
          total2={totalB}
          setTotal2={setTotalB}
          amount2={amountB}
          setAmount2={setAmountB}
          title3="Fornecedor C"
          minQuant3={Supplier[3].sacola.fornecedorC.minQuant}
          precoBase3={Supplier[3].sacola.fornecedorC.precoBase}
          leadTime3={Supplier[3].sacola.fornecedorC.leadTime}
          atraso3={Supplier[3].sacola.fornecedorC.atraso}
          confiabilidade3={Supplier[3].sacola.fornecedorC.confiabilidade}
          desconto3={Supplier[3].sacola.fornecedorC.desconto}
          provider3={providerC}
          setProvider3={setProviderC}
          inCash3={inCashC}
          setInCash3={setInCashC}
          thirtyDays3={thirtyDaysC}
          setThirtyDays3={setThirtyDaysC}
          sixtyDays3={sixtyDaysC}
          setSixtyDays3={setSixtyDaysC}
          total3={totalC}
          setTotal3={setTotalC}
          amount3={amountC}
          setAmount3={setAmountC}
        />
        <CountFooter total={totalA + totalB + totalC} />
        <FooterButton
          text="Confirmar"
          onHandle={handlePay}
        />
      </SizeContainer>
    </Container>
  );
};
export default ToolsPurchaseCarryBag;
